import { ref } from 'vue'
import { type User } from '@/gql/generate/graphql'

export const user = ref<User>()
